module.exports = __webpack_public_path__ + "static/media/extension.e4e205e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/recollect/extension.jpg
// module id = 348
// module chunks = 0